import ProjectRepository from '../../domain/repository/ProjectRepository';
import OrganizationStore from '../../domain/store/OrganizationStore';
import ProjectStore from '../../domain/store/ProjectStore';
import UiState from '../../domain/store/UiState';

export class ProjectUsecase {
  private projectRepository: ProjectRepository;
  private organizationStore: OrganizationStore;
  private projectStore: ProjectStore;
  private uiState: UiState;

  constructor({
    projectRepository,
    organizationStore,
    projectStore,
    uiState,
  }: {
    projectRepository: ProjectRepository;
    organizationStore: OrganizationStore;
    projectStore: ProjectStore;
    uiState: UiState;
  }) {
    this.projectRepository = projectRepository;
    this.organizationStore = organizationStore;
    this.projectStore = projectStore;
    this.uiState = uiState;
  }

  public async getProjects(organizationId: string) {
    const { projectRepository, projectStore, uiState } = this;
    uiState.clearError();
    await projectStore.setLoading(true);
    const projects = await projectRepository.getRoundReports(organizationId);
    if (projects.length === 0) {
      uiState.setError({
        title: 'この組織ではまだエクスペリエンスが作成されていません',
        message: '',
      });
    }
    await projectStore.setOrganizationProject(projects);
    await projectStore.setLoading(false);
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/application/usecase/ProjectUsecase.ts